// Copyright (c) 2022 by Move Closer

import { Variant } from '../../../../contexts'

import { toImageProps } from '../../support'
import { GalleryProps } from './Gallery.contracts'
import { Direction } from './partials/thumbnails/Thumbnails.contrats'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const translateProductVariantToGalleryProps = (variant: Variant<string>, isMobile?: boolean): GalleryProps => {
  const thumbnails = (variant && 'images' in variant) ? variant.images.map((image) => toImageProps(image)) : []
  const fullImages = (thumbnails) ? thumbnails.map(thumbnails => ({ ...thumbnails, fit: 'contain' })) : []
  const direction = isMobile ? Direction.Horizontal : Direction.Vertical
  const previewImages = fullImages

  const mobileCarousel = {
    autoplay: false,
    arrows: false,
    dots: true,
    hasButtons: false,
    initialSlide: 0,
    infinite: false,
    perPage: 1,
    variableWidth: true,
    vertical: false
  }

  const thumbnailsCarouselConfiguration = {
    autoplay: false,
    arrows: false,
    initialSlide: 0,
    infinite: false,
    perPage: 1,
    variableWidth: true,
    hasButtons: false,
    vertical: false
  }

  return {
    direction,
    mobileCarousel,
    previewImages,
    thumbnails,
    thumbnailsCarouselConfiguration,
    fullImages
  }
}
